// extracted by mini-css-extract-plugin
export default {"swatch":"Swatch_swatch__TSm15"};